import React, { Component } from 'react'
import { connect } from 'react-redux'
import {Grid, Checkbox, Radio, TextArea } from 'semantic-ui-react'
import InputField from '../formComponents/inputField'
import * as actionCreators from '../actions'
import _, { get } from "lodash";
import { getJobWheels } from '../../../src/util/index'

export const PSCIsAlreadyFiledPSCSTATES = ["STATE_PSC_REJECTED","STATE_PSC_ACCEPTED","STATE_PSC_ACCEPTED_WITH_WARNING","STATE_PSC_FILED"];

class DeclarationSection extends Component {
  decamelize(str, separator){
    separator = typeof separator === 'undefined' ? ' ' : separator;
    return _.startCase(str).replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
          .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
  }
  render() {
    let {
      formDisabled,
      actualOwnerFlag,
      purchaserFlag,
      trueInvoiceFlag,
      bestInvoiceFlag,
      updateDeclarationSectionField,
      saveDeclarationSectionFieldObject,
      pscData,
      pscState,
      currentJobData,
      shipmentCountry,
      isDisabled,
      pscChainRawResponse,
      shipmentId,
    } = this.props
    
    const forceChecked = PSCIsAlreadyFiledPSCSTATES.includes(get(pscState, 'value.state'));
    let pscChainSaysPSC = (pscChainRawResponse?.child || []).map(onechain=>onechain.humanReadableId).includes(shipmentId);
    const isPscDisableForm = !((get(pscState, 'value.state') === 'STATE_PSC_IN_PROCESS' || get(pscState, 'value.state')  === 'STATE_PSC_READY'));
    const pscDisabled = isPscDisableForm ? 'disableForm': '';
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    if(!isPscDisableForm){
      formDisabled = false;//enable this section for PSC, because values were getting lost
    }
    if(!isTheOwningBroker){
      formDisabled = true;
    }
    return (
      <>
      <div className='declaration-section'>
        <h4>DECLARATION OF IMPORTER OF RECORD OR AUTHORIZED AGENT</h4>
        I declare that I am the
        <Checkbox
          id='actualOwnerFlag'
          className=''
          label='Importer of record'
          checked={actualOwnerFlag === '1'}
          onChange={() => {
            let value = actualOwnerFlag === '1' ? '2' : '1'
            let value2 = actualOwnerFlag === '1' ? '1' : '2'
            updateDeclarationSectionField('actualOwnerFlag', value)
            updateDeclarationSectionField('purchaserFlag', value2)
        
        
            saveDeclarationSectionFieldObject({'actualOwnerFlag': value, 'purchaserFlag': value2})
            
          }}
          disabled={formDisabled && isDisabled('signSection',true)}
        />
        and that the actual owner, purchaser, or consignee for CBP purposes is as shown above, <b>OR</b>
        <Checkbox
          id='purchaserFlag'
          className=''
          label='owner or purchaser or agent'
          checked={purchaserFlag === '1'}
          onChange={() => {
            let value = purchaserFlag === '1' ? '2' : '1'
            let value2 = purchaserFlag === '1' ? '1' : '2'
            updateDeclarationSectionField('purchaserFlag', value)
            updateDeclarationSectionField('actualOwnerFlag', value2)
            saveDeclarationSectionFieldObject({'purchaserFlag': value, 'actualOwnerFlag': value2})
          }}
          disabled={formDisabled && isDisabled('signSection',true)}
        />
        thereof. I further declare that the merchandise
        <Checkbox
          id='trueInvoiceFlag'
          className=''
          label='was obtained'
          checked={trueInvoiceFlag === '1'}
          onChange={() => {
            let value = trueInvoiceFlag === '1' ? '2' : '1'
            let value2 = trueInvoiceFlag === '1' ? '1' : '2'
            updateDeclarationSectionField('trueInvoiceFlag', value)
            updateDeclarationSectionField('bestInvoiceFlag', value2)
            saveDeclarationSectionFieldObject({'trueInvoiceFlag': value, 'bestInvoiceFlag': value2})

          }}
          disabled={formDisabled && isDisabled('signSection',true)}
        />
        pursuant to a purchase or agreement to purchase and that the prices set forth in the invoices are true, <b>OR</b>
        <Checkbox
          id='bestInvoiceFlag'
          className=''
          label='was not obtained'
          checked={bestInvoiceFlag === '1'}
          onChange={() => {
            let value = bestInvoiceFlag === '1' ? '2' : '1'
            let value2 = bestInvoiceFlag === '1' ? '1' : '2'
            updateDeclarationSectionField('bestInvoiceFlag', value)
            updateDeclarationSectionField('trueInvoiceFlag', value2)
            saveDeclarationSectionFieldObject({'bestInvoiceFlag': value,'trueInvoiceFlag': value2})

          }}
          disabled={formDisabled && isDisabled('signSection',true)}
        />
        pursuant to a purchase or
        agreement to purchase and the statements in the invoices as to value or
        price are true to the best of my knowledge and belief. I also declare
        that the statements in the documents herein filed fully disclose to the
        best of my knowledge and belief the true prices, values, quantities,
        rebates, drawbacks, fees, commissions, and royalties and are true and
        correct, and that all goods or services provided to the seller of the
        merchandise either free or at reduced cost are fully disclosed. Importer
        of record and that the actual owner, was not obtained pursuant to a
        purchase or agreement to purchase and the statements in the invoices as
        to value or price are true to the best of my knowledge and belief. I
        will immediately furnish to the appropriate CBP officer any information
        showing a different statement of facts.
      </div>
      {
       (pscData.pscShipmentId || pscChainSaysPSC) &&  
       <div className={`pscDeclaration ${pscDisabled}`}>
         <div className='summary-heading'>Summary of Post Summary Correction: Complete and Click "PSC REVIEW" Button to verify.</div>
         {
         pscData.headerCodes &&  
         <Grid className='headerReasonList'>
           <Grid.Row>
           <Grid.Column width={11}><strong>Header Reason</strong></Grid.Column><Grid.Column width={5}><strong>Tab</strong></Grid.Column>
           </Grid.Row>
           {
            pscData.headerCodes && pscData.headerCodes.map((item)=>{
              if(item.reasonCodes && item.reasonCodes.length){
                return (
                  <Grid.Row>
                    <Grid.Column width={11}>{
                      item.reasonCodes && item.reasonCodes.map((_item)=>{
                          return (
                            <div><span><strong>{_item.code}</strong></span><span> - </span><span>{_item.desc}</span></div>
                          )
                      })
                    }
                    </Grid.Column><Grid.Column width={5}>{this.decamelize(item.key)=='Merchandise'?'Line Items':this.decamelize(item.key)}</Grid.Column>
                  </Grid.Row>
                )
              }
            })
           }
         </Grid>
         }
          {
         pscData.lineCodes &&   
         <Grid className='lineReasonList'>
           <Grid.Row>
           <Grid.Column width={11}><strong>Line Reason</strong></Grid.Column><Grid.Column width={5}><strong>Merchandise</strong></Grid.Column>
            
           </Grid.Row>
           {
           pscData.lineCodes && pscData.lineCodes.map((item)=>{
              if(item.reasonCodes && item.reasonCodes.length){
               return (
                 <Grid.Row>
                  <Grid.Column width={11}>{
                    item.reasonCodes && item.reasonCodes.map((_item)=>{
                        return (
                          <div><span><strong>{_item.code}</strong></span><span> - </span><span>{_item.desc}</span></div>
                        )
                    })
                  }</Grid.Column><Grid.Column width={5}>{`Line ${item.lineItemIndex}`}</Grid.Column>
                </Grid.Row>
              )
              }
            })
           }
         </Grid>
         }
         <Grid>
           <Grid.Row>
             <Grid.Column width={10}>PSC FILING EXPLANATION</Grid.Column><Grid.Column width={6}>ACCELERATED LIQUIDATION</Grid.Column>
           </Grid.Row>
           <Grid.Row>
             <Grid.Column width={10}>
               <TextArea
                id={`pscExplaination`}
                type={'text'}
                style={{"width": "100%", padding:'5px'}}
                className={'field-bg'}
                value={pscData.pscFileExplanation}
                handleFocus={e => {
                  e.target.select()
                }}
                onChange={event => {
                  this.props.updatePscData({
                    "pscFileExplanation": event.target.value
                  })
                }}
                onBlur={event => {
                  this.props.savePscData({
                    "pscFileExplanation": event.target.value
                  })
                }}
                disabled={formDisabled && isDisabled('signSection',true)}
              /></Grid.Column>
             <Grid.Column width={6}><Radio
                    id={"accelarated_yes"}
                    label={"Yes"}
                    name={"accelarated"}
                    checked={pscData.accelaratedLiquidation === 1}
                    onClick={value => {
                      this.props.updatePscData({
                        "accelaratedLiquidation": 1
                      })
                      this.props.savePscData({
                        "accelaratedLiquidation": 1
                      })
                    }}
                    disabled={formDisabled && isDisabled('signSection',true)}
                />
                <Radio
                    id={"accelarated_no"}
                    label={"No"}
                    name={"accelarated"}
                    value={"2"}
                    checked={pscData.accelaratedLiquidation === 2}
                    onClick={value => {
                      this.props.updatePscData({
                        "accelaratedLiquidation": 2
                      })
                      this.props.savePscData({
                        "accelaratedLiquidation": 2
                      })
                    }}
                    disabled={formDisabled && isDisabled('signSection',true)}
                /></Grid.Column>
           </Grid.Row>
         </Grid>
         <div><Checkbox
          id='confirmPsc'
          className=''
          label='I Confirm PSC to be the importer’s assertion that the entry summary data is correct.'
          checked={forceChecked || pscData.confirmPSC === '1'}
          onChange={() => {
            let value =
            pscData.confirmPSC === '1' ? '2' : '1'
            this.props.updatePscData({
              "confirmPSC": value
            })
            document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
          }}
          disabled={formDisabled && isDisabled('signSection',true)}
        />  </div>
       </div>   

        }
        </>
    )
  }
}

const mapStateToProps = state => ({
  formDisabled: state.FormValues.formDisabled,
  shipmentId: state.FormValues.shipmentId,
  actualOwnerFlag: state.DeclarationSection.actualOwnerFlag,
  purchaserFlag: state.DeclarationSection.purchaserFlag,
  trueInvoiceFlag: state.DeclarationSection.trueInvoiceFlag,
  bestInvoiceFlag: state.DeclarationSection.bestInvoiceFlag,
  pscChainRawResponse: state.PscChainRawResponse,
  tabName: "declaration",
  pscData: state.PSC
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclarationSection)
